import { Component, ReactNode } from 'react';
import { Icon, Tooltip } from '@mui/material';
import { WithStyles, createStyles, withStyles } from '@mui/styles';

const styles = () =>
    createStyles({
        iconTooltip: {
            fontSize: 13,
        },
    });

interface PriceMatrixFooterTermProps extends WithStyles<typeof styles> {
    icon: string;
    tooltip?: ReactNode;
}

class PriceMatrixFooterTermBase extends Component<PriceMatrixFooterTermProps> {
    public render() {
        const { icon, tooltip, classes } = this.props;

        return (
            <Tooltip title={tooltip || ''} classes={{ tooltip: classes.iconTooltip }} placement="top">
                <Icon className={icon} color={tooltip ? 'primary' : 'disabled'} />
            </Tooltip>
        );
    }
}

export const PriceMatrixFooterTerm = withStyles(styles)(PriceMatrixFooterTermBase);
